import { AxiosError } from 'axios';
import axios from './axios';
import { queryClient } from 'src/core/react-query';
import { useAuthorizationContext } from 'src/components/authorization';
import { useMutation } from 'react-query';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export interface UseUploadAvatarVariables {
  avatar: string | null;
}

export interface UseUploadAvatarData {}

export function useUploadAvatar() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { setUser } = useAuthorizationContext();

  return useMutation<
    UseUploadAvatarData,
    AxiosError<never>,
    UseUploadAvatarVariables
  >(
    (variables) => {
      const data = { avatar_id: variables.avatar };

      return axios
        .put<UseUploadAvatarData>('/posht/ashena/me/profile/avatar/', data)
        .then((res) => res.data);
    },
    {
      onError: (error) => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        queryClient.invalidateQueries('profile');
        queryClient.fetchQuery('user-info').then((data: any) => {
          if (!!data) {
            setUser(data);
          }
        });
      },
    },
  );
}
